import { ProfileHeader } from './ProfileHeader'

const AvatarDropdown = () => {
  return (
    <div className="AvatarDropdown">
      <ProfileHeader />
    </div>
  )
}

export default AvatarDropdown
